/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_Titleorid2Inputs */

const id_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul/ID`)
};

const ms_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk/ID`)
};

const da_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel/ID`)
};

const de_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel/ID`)
};

const en_us2_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title/ID`)
};

const es_es2_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título/ID`)
};

const es_mx2_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título/ID`)
};

const fil_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamagat/ID`)
};

const fr_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre/ID`)
};

const it_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo/ID`)
};

const hu_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cím/Azonosító`)
};

const nl_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel/ID`)
};

const no_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittel/ID`)
};

const pl_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł/ID`)
};

const pt_br2_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title or ID`)
};

const pt_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título/ID`)
};

const ro_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlu/ID`)
};

const fi_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikko/tunnus`)
};

const sv_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel/ID`)
};

const vi_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề/ID`)
};

const tr_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık/ID`)
};

const cs_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název/ID`)
};

const bg_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавие/ID`)
};

const ru_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название/ID`)
};

const uk_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва/ID`)
};

const ar_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان/المعرف`)
};

const hi_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक/ID`)
};

const th_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ/ID`)
};

const ja_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル/ID`)
};

const zh_cn2_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title or ID`)
};

const zh_hant1_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title or ID`)
};

const ko_components_changelist_titleorid2 = /** @type {(inputs: Components_Changelist_Titleorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title or ID`)
};

/**
* | output |
* | --- |
* | "Title/ID" |
*
* @param {Components_Changelist_Titleorid2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_titleorid2 = /** @type {((inputs?: Components_Changelist_Titleorid2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_Titleorid2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_titleorid2(inputs)
	if (locale === "ms") return ms_components_changelist_titleorid2(inputs)
	if (locale === "da") return da_components_changelist_titleorid2(inputs)
	if (locale === "de") return de_components_changelist_titleorid2(inputs)
	if (locale === "en-US") return en_us2_components_changelist_titleorid2(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_titleorid2(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_titleorid2(inputs)
	if (locale === "fil") return fil_components_changelist_titleorid2(inputs)
	if (locale === "fr") return fr_components_changelist_titleorid2(inputs)
	if (locale === "it") return it_components_changelist_titleorid2(inputs)
	if (locale === "hu") return hu_components_changelist_titleorid2(inputs)
	if (locale === "nl") return nl_components_changelist_titleorid2(inputs)
	if (locale === "no") return no_components_changelist_titleorid2(inputs)
	if (locale === "pl") return pl_components_changelist_titleorid2(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_titleorid2(inputs)
	if (locale === "pt") return pt_components_changelist_titleorid2(inputs)
	if (locale === "ro") return ro_components_changelist_titleorid2(inputs)
	if (locale === "fi") return fi_components_changelist_titleorid2(inputs)
	if (locale === "sv") return sv_components_changelist_titleorid2(inputs)
	if (locale === "vi") return vi_components_changelist_titleorid2(inputs)
	if (locale === "tr") return tr_components_changelist_titleorid2(inputs)
	if (locale === "cs") return cs_components_changelist_titleorid2(inputs)
	if (locale === "bg") return bg_components_changelist_titleorid2(inputs)
	if (locale === "ru") return ru_components_changelist_titleorid2(inputs)
	if (locale === "uk") return uk_components_changelist_titleorid2(inputs)
	if (locale === "ar") return ar_components_changelist_titleorid2(inputs)
	if (locale === "hi") return hi_components_changelist_titleorid2(inputs)
	if (locale === "th") return th_components_changelist_titleorid2(inputs)
	if (locale === "ja") return ja_components_changelist_titleorid2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_titleorid2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_titleorid2(inputs)
	return ko_components_changelist_titleorid2(inputs)
});
export { components_changelist_titleorid2 as "components.changelist.titleOrId" }